// #33939 — Loss History Detail. The entry shape, date normalization, the manual-entry writer, the
// summary rollup, and the source labels all live in the ONE shared module (@ourbranch/farm-utils)
// so the FE, the IMT importer, the A+ pull, and the rater can't drift. `addedBy` is stamped
// SERVER-SIDE on save (policy-mod / offer, from the acting user's identity) — the FE never sets it.
export {
  MANUAL_ENTRY_SOURCE,
  LOSS_SUMMARY_WINDOWS,
  isManualEntry,
  hydrateLossEntryForForm,
  buildManualEntry,
  summarizeLossHistory
} from '@ourbranch/farm-utils';

// The Ignore control (exclude an entry from rollup + rating) is UW-only, everywhere (offers and
// policies) — Ignore changes the claim-free discount, so only an underwriter may set it.
export const canIgnoreLossEntries = ({ isUnderwriter }) => !!isUnderwriter;
